import { useRef, useCallback } from 'react';

const useAnimationFrame = (cb, deps) => {
    const timeout = useRef();
    const handler = useCallback(() => {
        if (timeout.current) {
            window.cancelAnimationFrame(timeout.current);
        }
        timeout.current = window.requestAnimationFrame(() => {
            cb();
        });
    }, deps);
    return handler;
};

export { useAnimationFrame };
//# sourceMappingURL=useAnimationFrame.js.map
